import type { ComponentType } from "react";
import type { DocumentType } from "@/shell/route";
import type { RendererProps } from "./types";

// Per-doc-type code splitting: each renderer is its own lazy
// chunk, and main.tsx kicks the matching import off eagerly from the parsed
// path at boot — the chunk download overlaps the postMessage handshake, and a
// transcript load never downloads PDF code.

type RendererModule = { default: ComponentType<RendererProps> };

const loaders: Record<DocumentType, () => Promise<RendererModule>> = {
  research: () => import("./research/index"),
  transcript: () => import("./transcript/index"),
  filing: () => import("./filing/index"),
};

export function loadRenderer(type: DocumentType): Promise<RendererModule> {
  return loaders[type]();
}
